import axios from 'axios';

export const TOKEN_HEADER = 'token-secret';
export const SESSION_STORAGE_KEY = 'ica_state';

export class SessionStorageUtils {
  static getToken() {
    const state = this.getIcaState();
    return state && state.auth && state.auth.token ? state.auth.token : null;
  }

  static getIcaState() {
    const state = sessionStorage.getItem(SESSION_STORAGE_KEY);
    return state ? JSON.parse(state) : null;
  }

  static setToken = (token: string) => {
    if (token) {
      axios.defaults.headers.common[TOKEN_HEADER] = token;
    } else {
      delete axios.defaults.headers.common[TOKEN_HEADER];
    }
  };
  static removeIcaState = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  };
}
